import React from "react";
import { Redirect } from "react-router-dom";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import ForgetPwd from "../pages/Authentication/ForgetPassword";
import ResetPwd from "../pages/Authentication/ResetPassword";

// Managers links
import Dashboard from "../pages/Dashboard";
import Battlefield from "../pages/Battlefield/index";
import Priority from "../pages/Priority";
import LostOrders from "../pages/LostOrders/index";
import CustomerService from "../pages/CustomerService";
import Transfers from "../pages/Transfers";
import Transfers_moscow from "../pages/Transfers/transferMoscow";
import transfers_shipping from "../pages/Transfers/transferShipping";
import priority_moscow from "../pages/Priority/PriorityMoscow";
import priority_ukraine from "../pages/Priority/PriorityUkraine";
import PriorityUAE from "../pages/Priority/PriorityUAE";
import PriorityPL from "../pages/Priority/PriorityPL";
import priority_usa from "../pages/Priority/priorityUsa";
import Agents from "../pages/Transfers/agents";
import ActShipping from "../pages/ActShipping";
// import Calculator from '../pages/Calculator';
import CalculatorInfo from "../pages/Calculator/info";
import CalculatorEurope from "../pages/Calculator/calculatorEurope";
import CalculatorPoland from "../pages/Calculator/calculatorPoland";
import CalculatorFedex from "../pages/Calculator/calculatorFedex";
// import Data from '../pages/Calculator/data';
// import MskData from '../pages/Calculator/msk';
import Meetings from "../pages/Meeting/index";
import NewClients from "../pages/Stats/newClients";
import ProductsToOrder from "../pages/Purchases/product";
import Purchases from "../pages/Purchases/purchase";
import Logistic from "../pages/Logistic";
import PriceList from "../pages/PriceList/index";
import PriceInfo from "../pages/PriceList/info";
import Leaves from "../pages/Leaves";
import Catalog from "../pages/Catalog";
// Clients Orders And Payments
import ClientOrder from "../pages/ClientOrder/order";
import PayoneerOrder from "../pages/ClientOrder/payoneer";

// Marketing Department Tab
import DomainsList from "../pages/Marketing/domains";
import SubsList from "../pages/Marketing/subs";

// import KanbanBoard from '../pages/CRM/KanbanBoard/KanbanBoard';
// Admin links
import Users from "../pages/Users/index";
import Departments from "../pages/Departments/index";
import Accesses from "../pages/Departments/access";

const authProtectedRoutes = [
  { path: "/dashboard", component: Dashboard },
  // ADMIN PAGES
  { path: "/users", component: Users },
  { path: "/departments", component: Departments },
  { path: "/accesses", component: Accesses },
  // MANAGERS PAGES
  { path: "/battlefield", component: Battlefield },
  { path: "/lost_orders", component: LostOrders },
  { path: "/priority", component: Priority },
  { path: "/customer_service", component: CustomerService },
  { path: "/new_clients", component: NewClients },
  // AGNETS AND TRANSFERS
  { path: "/transfers", component: Transfers },
  { path: "/inventory_moscow", component: Transfers_moscow },
  { path: "/priority_moscow", component: priority_moscow },
  { path: "/priority_ukraine", component: priority_ukraine },
  { path: "/priority_uae", component: PriorityUAE },
  { path: "/priority_pl", component: PriorityPL },
  { path: "/priority_usa", component: priority_usa },
  { path: "/shipping_moscow", component: transfers_shipping },
  { path: "/agents", component: Agents },
  // DATA AND CALCULATOR
  // { path: '/calculator', component: Calculator },
  { path: "/calculator_info", component: CalculatorInfo },
  { path: "/calculator_europe", component: CalculatorEurope },
  { path: "/calculator_wroclaw", component: CalculatorPoland },
  { path: "/calculator_fedex", component: CalculatorFedex },
  // { path: '/msk_data', component: MskData },
  // ACTIVIDAN SHIPPING
  { path: "/actividan_shipping", component: ActShipping },
  // PURCHASES
  { path: "/products", component: ProductsToOrder },
  { path: "/purchases", component: Purchases },
  { path: "/fees", component: Logistic },
  // MEETINGS
  { path: "/meeting_booking", component: Meetings },
  // PRICE LIST
  { path: "/price_list", component: PriceList },
  { path: "/price_data", component: PriceInfo },
  // DOMAINS LIST
  { path: "/domains", component: DomainsList },
  { path: "/subs", component: SubsList },
  // { path: '/leads', component: KanbanBoard },
  // DOMAINS LIST
  { path: "/leave_apply", component: Leaves },
  { path: "/client_orders", component: ClientOrder },
  { path: "/payoneer_requests", component: PayoneerOrder },
  // this route should be at the end of all other routes
  // { path: '/', exact: true, component: () => <Redirect to='/dashboard' /> }
  { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
];

const publicRoutes = [
  { path: "/login", component: Login },
  { path: "/logout", component: Logout },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/catalog", component: Catalog },
  { path: "/passwordreset", component: ResetPwd },
];

export { authProtectedRoutes, publicRoutes };
